export default __webpack_public_path__ + "static/media/G0550.34I-26304_-22028_0.7351bbfb.jpg";